export default __webpack_public_path__ + "stumbler-second.2081a4ee.mp4";